import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Nullable } from '@/Types';
import { GenerateNumberRequest } from 'src/Api/MpOrders';

export type GenerateDocumentNumberConfirmationModalState = {
  numberGenerateRequest: Nullable<GenerateNumberRequest>;
};

const initialState: GenerateDocumentNumberConfirmationModalState = {
  numberGenerateRequest: null,
};

const generateDocumentNumberConfirmationModalSlice = createSlice({
  name: 'generateDocumentNumberConfirmationModal',
  initialState,
  reducers: {
    resetState: () => initialState,
    setNumberGenerationRequest: (state, action: PayloadAction<Nullable<GenerateNumberRequest>>) => {
      state.numberGenerateRequest = action.payload;
    },
  },
});

const { reducer, actions } = generateDocumentNumberConfirmationModalSlice;

export const generateDocumentNumberConfirmationModalReducer = reducer;
export const generateDocumentNumberConfirmationModalActions = actions;
